import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWebfxLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1375.62 362.85",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".d{fill:#fff}.f{fill:#272727}" }) }), /* @__PURE__ */ _jsx("g", {
		id: "b",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "c",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M334.88 49.91h48.68L301.35 327.3h-51.49l-58.27-209.94-61.88 209.94-51.09.42L0 49.91h48.29l57.49 225.92 62.26-225.92h51.08L277 274.63l57.88-224.72zM481.73 330.92c-31.92 0-57.84-10.41-77.82-31.15-19.96-20.78-29.92-48.31-29.92-82.63s10.11-61.79 30.31-82.41c20.23-20.62 46.38-30.92 78.43-30.92s58.06 9.9 78.04 29.73c19.96 19.8 29.92 45.7 29.92 77.63 0 7.7-.52 14.9-1.58 21.53H420.68c1.07 18.39 7.24 32.94 18.56 43.72 11.3 10.78 25.47 16.15 42.49 16.15 24.77 0 42.18-10.25 52.3-30.73h49.09c-6.66 20.24-18.76 36.8-36.32 49.69-17.57 12.92-39.26 19.39-65.08 19.39m43.51-172.64c-11.71-10.78-25.95-16.16-42.7-16.16s-30.82 5.38-42.12 16.16c-11.32 10.78-17.76 25.21-19.36 43.31h122.14c-.27-18.1-6.25-32.53-17.96-43.31M741.58 103.81c29.54 0 54.14 10.43 73.84 31.3 19.67 20.9 29.54 48.06 29.54 81.43s-9.92 60.82-29.75 82.22c-19.81 21.43-44.38 32.15-73.64 32.15-17.29 0-32.47-4.09-45.5-12.2-13.04-8.11-23.41-18.95-31.14-32.53v41.1h-45.49V31.96h45.49v114.53c7.45-12.76 17.77-23.07 30.94-30.93 13.17-7.86 28.41-11.75 45.7-11.75m37.12 167.01c13.31-13.7 19.97-31.87 19.97-54.47s-6.6-40.45-19.77-53.49-28.88-19.55-47.1-19.55-33.93 6.63-47.1 19.96c-13.17 13.3-19.77 31.24-19.77 53.87s6.6 40.64 19.77 54.09c13.17 13.42 28.79 20.14 46.89 20.14s33.79-6.85 47.1-20.55",
					className: "f"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M867.55 0h508.07v362.85H867.55z",
					style: { fill: "#5a73b3" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M925.8 55.85v257.53h66.41V212.81h89.92v-56.39h-89.92v-44.59h110.87l-34.29-55.98H925.8z",
					className: "d"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M1333.86 313.38h-76.57l-82.8-128.76 79.69-128.77h79.68l-79.68 128.77 79.68 128.76z",
					style: { fill: "#a8b6d9" }
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M1094.82 55.85h76.57l82.79 128.77-79.69 128.76h-79.67l79.67-128.76-79.67-128.77z",
					className: "d"
				})
			]
		})
	})]
});
export default SvgWebfxLogo;
